import { Injectable } from '@angular/core';
import {HttpClient} from "../http.client";

@Injectable()
export class NotificationService {

  constructor(private _http: HttpClient) { }

  sendNotification(text: string, body: string, country:any, id:any, poc_id:any, group_id:any, lot_id:any) {
      return this._http.post("/notifications/sendNotification", {
          text: text,
          body: body,
          country: country,
          id: id,
          poc_id: poc_id,
          group_id: group_id,
          lot_id: lot_id,
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/notifications/notification.service.ts